import {
  styled,
  rem
} from 'config/stitches.config'

import Link from '@/UI/Link'

export const StyledLogo = styled(Link, {
  gridArea: 'logo',
  justifySelf: 'start',
  paddingRight: '$3',
  pointerEvents: 'auto',
  padding: 0,
  width: rem(180),
  height: 'auto',
  position: 'relative',
  '@md': {
    height: '100%',
    width: '100%',
  },
  '@logo': { width: '100%' },

  '.desktop-logo': {
    display: 'none',
    '@logo': {
      display: 'block',
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    }
  },

  '.mobile-logo': {
    display: 'block',
    objectFit: 'contain',
    width: rem(180),
    height: 'auto',
    '@logo': { display: 'none' }
  }
})
